
(function(){
  // Supplier stock yarn colours (Changzhou Grace Grass). Hex values are
  // indicative screen approximations - production colour is confirmed on the
  // design render. A request converts straight to a PO via the A-code.
  // Colour data + image URLs are rendered by the Liquid section so images
  // are served from the Shopify CDN instead of being embedded in the page.
  var CFG = JSON.parse(document.getElementById('turf-config-data').textContent);
  var COLOURS = CFG.colours;
  var state = { w:2.0, l:10, colour:COLOURS[3], custom:null, logoDataUrl:null, logoName:null, placement:'centre', border:false, marks:false, freight:'sea', logoX:50, logoY:50, logoRot:0 };
  var logoSlotEl = null;   // reference to the draggable single-logo element

  // Pricing model - AUD per m2 ex GST, derived from historical NetSuite quotes.
  // Logo and markings carry no surcharge (supplier bills a flat rate per m2).
  var RATE = CFG.rate || { sea:175, air:270 };
  var MIN_EX = CFG.minEx || 1500;   // minimum order value ex GST (theme setting)
  var GST = 1.1;
  function money(n){ return '$' + Math.round(n).toLocaleString('en-AU'); }
  function estimate(){
    var area = state.w * state.l;
    var raw = area * RATE[state.freight];
    var atMin = raw < MIN_EX;
    var ex = Math.round(Math.max(MIN_EX, raw) / 10) * 10;
    return { area:area, ex:ex, inc:Math.round(ex * GST), atMin:atMin };
  }

  var turf = document.getElementById('turf');
  var turfLogos = document.getElementById('turfLogos');
  var stage = document.querySelector('.preview-stage');
  var dimL = document.getElementById('dimLength');
  var dimW = document.getElementById('dimWidth');
  var areaOut = document.getElementById('areaOut');
  var sumSize = document.getElementById('sumSize');
  var sumArea = document.getElementById('sumArea');
  var sumColour = document.getElementById('sumColour');
  var sumDot = document.getElementById('sumDot');
  var sumLogo = document.getElementById('sumLogo');
  var sumMarks = document.getElementById('sumMarks');
  var sumFreight = document.getElementById('sumFreight');
  var sumPrice = document.getElementById('sumPrice');
  var priceMain = document.getElementById('priceMain');

  function clamp(v,min,max){ return Math.min(max, Math.max(min, v)); }
  function fmt(n){ return (Math.round(n*10)/10).toString(); }

  function nearestCode(r,g,b){
    var best=null, bd=Infinity;
    COLOURS.forEach(function(c){
      var h=c.hex.replace('#','');
      var cr=parseInt(h.substr(0,2),16), cg=parseInt(h.substr(2,2),16), cb=parseInt(h.substr(4,2),16);
      var d=(r-cr)*(r-cr)+(g-cg)*(g-cg)+(b-cb)*(b-cb);
      if(d<bd){ bd=d; best=c; }
    });
    return best;
  }
  function activeColour(){
    if (state.custom){
      var n = nearestCode(state.custom.r, state.custom.g, state.custom.b);
      return { label:'Custom RGB \u2248 ' + n.code + ' ' + n.name, hex:'rgb(' + state.custom.r + ',' + state.custom.g + ',' + state.custom.b + ')' };
    }
    return { label:state.colour.code + ' ' + state.colour.name, hex:state.colour.hex };
  }

  function isLight(hex){
    var r,g,b;
    if (hex.indexOf('rgb') === 0) {
      var m = hex.match(/\d+/g); r=+m[0]; g=+m[1]; b=+m[2];
    } else {
      r = parseInt(hex.substr(1,2),16); g = parseInt(hex.substr(3,2),16); b = parseInt(hex.substr(5,2),16);
    }
    return (0.299*r + 0.587*g + 0.114*b) > 160;
  }

  function applyLogoTransform(el){
    el.style.transform = 'translate(-50%, -50%) rotate(' + state.logoRot + 'deg)';
  }
  function attachLogoDrag(el){
    el.addEventListener('pointerdown', function(e){
      e.preventDefault();
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      var rect = turf.getBoundingClientRect();
      function move(ev){
        var x = (ev.clientX - rect.left) / rect.width * 100;
        var y = (ev.clientY - rect.top) / rect.height * 100;
        state.logoX = Math.max(0, Math.min(100, x));
        state.logoY = Math.max(0, Math.min(100, y));
        el.style.left = state.logoX + '%';
        el.style.top = state.logoY + '%';
      }
      function up(){
        el.removeEventListener('pointermove', move);
        el.removeEventListener('pointerup', up);
      }
      el.addEventListener('pointermove', move);
      el.addEventListener('pointerup', up);
    });
  }
  function updateLogoControls(){
    var single = state.placement === 'centre';
    document.getElementById('logoDragHint').style.display = single ? '' : 'none';
    document.getElementById('logoReset').style.display = single ? '' : 'none';
  }

  function renderPreview(){
    var stageW = stage.clientWidth - 60;
    var stageH = stage.clientHeight - 60;
    var scale = Math.min(stageW / state.l, stageH / state.w);
    var pxL = Math.max(120, state.l * scale);
    var pxW = Math.max(44, state.w * scale);
    turf.style.width = pxL + 'px';
    turf.style.height = pxW + 'px';
    var c = activeColour();
    turf.style.backgroundColor = c.hex;
    dimL.textContent = fmt(state.l) + ' m';
    dimW.textContent = fmt(state.w) + ' m';

    // logos
    turfLogos.innerHTML = '';
    logoSlotEl = null;
    var light = isLight(c.hex);
    function fillSlot(slot){
      if (state.logoDataUrl){
        var img = document.createElement('img');
        img.src = state.logoDataUrl;
        img.alt = 'Your logo';
        slot.appendChild(img);
      } else {
        var ph = document.createElement('span');
        ph.className = 'turf__logo-ph';
        ph.textContent = 'Your Logo';
        if (light){ ph.style.color = 'rgba(0,0,0,0.65)'; ph.style.borderColor = 'rgba(0,0,0,0.4)'; }
        if (pxW < 70){ ph.style.padding = '3px 8px'; ph.style.fontSize = '9px'; }
        slot.appendChild(ph);
      }
    }

    if (state.placement === 'repeat'){
      // evenly distributed along the run, all share the rotation
      turfLogos.style.display = 'flex';
      turfLogos.style.pointerEvents = 'none';
      var count = Math.max(2, Math.round(state.l / 5));
      for (var i=0; i<count; i++){
        var slot = document.createElement('div');
        slot.className = 'turf__logo-slot';
        slot.style.height = Math.round(pxW * 0.62) + 'px';
        slot.style.maxWidth = Math.round(pxL / count * 0.7) + 'px';
        slot.style.transform = 'rotate(' + state.logoRot + 'deg)';
        fillSlot(slot);
        turfLogos.appendChild(slot);
      }
    } else {
      // single logo: absolutely positioned, rotatable and draggable
      turfLogos.style.display = 'block';
      turfLogos.style.pointerEvents = 'none';
      var slot = document.createElement('div');
      slot.className = 'turf__logo-slot turf__logo-slot--drag';
      slot.style.position = 'absolute';
      slot.style.left = state.logoX + '%';
      slot.style.top = state.logoY + '%';
      slot.style.height = Math.round(pxW * 0.62) + 'px';
      slot.style.maxWidth = Math.round(pxL * 0.7) + 'px';
      slot.style.pointerEvents = 'auto';
      applyLogoTransform(slot);
      fillSlot(slot);
      attachLogoDrag(slot);
      turfLogos.appendChild(slot);
      logoSlotEl = slot;
    }

    // markings - the white line sits just inside the edge so it reads
    // against both the turf and the light panel behind the preview
    var oldB = turf.querySelector('.turf__border'); if (oldB) oldB.remove();
    var oldM = turf.querySelector('.turf__marks'); if (oldM) oldM.remove();
    var bw = Math.max(2, Math.round(scale * 0.05));
    if (state.border){
      var bd = document.createElement('div');
      bd.className = 'turf__border';
      bd.style.inset = '0';   // flush to the turf edge - no black outside the border
      bd.style.border = bw + 'px solid #FFFFFF';
      turf.appendChild(bd);
    }
    if (state.marks){
      var mk = document.createElement('div');
      mk.className = 'turf__marks';
      var dashInset = state.border ? (bw + 4) : 3;
      for (var mi = 1; mi < state.l; mi++){
        ['top','bottom'].forEach(function(edge){
          var d = document.createElement('span');
          d.style.left = Math.round(mi * (pxL / state.l)) + 'px';
          d.style[edge] = dashInset + 'px';
          mk.appendChild(d);
        });
      }
      turf.appendChild(mk);
    }
  }

  function renderSummary(){
    var c = activeColour();
    sumSize.textContent = fmt(state.w) + ' m \u00d7 ' + fmt(state.l) + ' m';
    var area = state.w * state.l;
    var areaTxt = (Math.round(area*10)/10) + ' m\u00b2';
    sumArea.textContent = areaTxt;
    areaOut.textContent = areaTxt;
    sumColour.innerHTML = '';
    var dot = document.createElement('span');
    dot.className = 'cfg-summary__dot';
    dot.style.background = c.hex;
    sumColour.appendChild(dot);
    sumColour.appendChild(document.createTextNode(c.label));
    sumLogo.textContent = state.logoName ? state.logoName + (state.placement === 'repeat' ? ' (repeated)' : ' (single)') : 'Not uploaded yet';
    var marksList = [];
    if (state.border) marksList.push('White border');
    if (state.marks) marksList.push('Metre dashes');
    sumMarks.textContent = marksList.length ? marksList.join(' + ') : 'None';
    sumFreight.textContent = CFG.isUs ? CFG.usCopy.quote_delivery : (state.freight === 'air' ? 'Priority (air freight)' : 'Standard (sea freight)');

    if (CFG.isUs) {
      priceMain.textContent = CFG.usCopy.quote;
      sumPrice.textContent = CFG.usCopy.quote;
      document.getElementById('priceExLine').textContent = CFG.usCopy.quote_detail;
      return;
    }

    // live price estimate
    var e = estimate();
    priceMain.innerHTML = money(e.inc) + ' <span class="gst">inc GST</span>';
    sumPrice.innerHTML = money(e.inc) + ' <small>inc GST</small>';
    document.getElementById('priceExLine').innerHTML = e.atMin
      ? '<span class="pdp__price-min">Minimum order</span> &middot; ' + money(e.ex) + ' ex GST &middot; estimate updates as you build'
      : '<strong>' + money(e.ex) + '</strong> ex GST &middot; estimate updates as you build';
  }

  function exampleColour(){ return state.custom ? nearestCode(state.custom.r, state.custom.g, state.custom.b) : state.colour; }
  function renderColourExample(){
    var el = document.getElementById('colourExample');
    if (!el) return;
    var c = exampleColour();
    var texClass = 'colour-example__tex' + (c.photo ? ' colour-example__tex--photo' : '');
    var texStyle = c.photo ? ('background-color:' + c.hex + ';background-image:url(' + c.photo + ')') : ('background-color:' + c.hex);
    var lane = c.lane
      ? '<img class="colour-example__lane" src="' + c.lane + '" alt="' + c.code + ' ' + c.name + ' turf lane example" />'
      : '<div class="colour-example__lane colour-example__lane--ph">Real-life turf lane<br/><span>photo added per colour</span></div>';
    var prefix = state.custom ? 'Closest stock colour: ' : 'Selected colour: ';
    el.innerHTML =
      '<div class="colour-example__head">' + prefix + '<strong>' + c.code + ' ' + c.name + '</strong></div>' +
      '<div class="colour-example__row">' +
        '<div class="' + texClass + '" style="' + texStyle + '"><span class="colour-example__lbl">Texture</span></div>' +
        '<div class="colour-example__lanewrap"><span class="colour-example__lbl">Turf lane example</span>' + lane + '</div>' +
      '</div>';
  }
  function renderAll(){ renderPreview(); renderSummary(); updateLogoControls(); renderColourExample(); }

  // size controls
  var lN = document.getElementById('lengthNum'), lR = document.getElementById('lengthRange');
  var widthOpts = document.querySelectorAll('#widthOpts .width-opt');
  function setW(v){
    state.w = (v === 1 || v === 2 || v === 4) ? v : 2;
    widthOpts.forEach(function(b){ b.classList.toggle('width-opt--active', parseFloat(b.getAttribute('data-w')) === state.w); });
    renderAll();
  }
  function setL(v){ state.l = clamp(parseFloat(v)||2, 2, 25); lN.value = fmt(state.l); lR.value = state.l; renderAll(); }
  widthOpts.forEach(function(b){ b.addEventListener('click', function(){ setW(parseFloat(b.getAttribute('data-w'))); }); });
  lR.addEventListener('input', function(){ setL(this.value); });
  lN.addEventListener('change', function(){ setL(this.value); });

  // swatches
  var swWrap = document.getElementById('swatches');
  COLOURS.forEach(function(c, i){
    var el = document.createElement('div');
    el.className = 'swatch' + (c.code === state.colour.code ? ' swatch--active' : '');
    el.setAttribute('role','button');
    el.setAttribute('tabindex','0');
    var tag = c.tag ? '<span class="swatch__tag">' + c.tag + '</span>' : '';
    // If a real supplier photo is set on the colour, show it; otherwise show
    // the procedural turf texture tinted to the colour's hex.
    var chipClass = 'swatch__chip' + (c.photo ? ' swatch__chip--photo' : '');
    var chipStyle = c.photo ? ('background-color:' + c.hex + ';background-image:url(' + c.photo + ')') : ('background-color:' + c.hex);
    el.innerHTML = '<div class="' + chipClass + '" style="' + chipStyle + '">' + tag + '</div><span class="swatch__code">' + c.code + '</span><span class="swatch__name">' + c.name + '</span>';
    function pick(){
      state.colour = c; state.custom = null;
      Array.prototype.forEach.call(swWrap.children, function(s){ s.classList.remove('swatch--active'); });
      el.classList.add('swatch--active');
      renderAll();
    }
    el.addEventListener('click', pick);
    el.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(); } });
    swWrap.appendChild(el);
  });

  // custom RGB
  var rI = document.getElementById('rgbR'), gI = document.getElementById('rgbG'), bI = document.getElementById('rgbB');
  var chip = document.getElementById('rgbChip');
  function rgbVals(){
    var r = clamp(parseInt(rI.value,10)||0,0,255), g = clamp(parseInt(gI.value,10)||0,0,255), b = clamp(parseInt(bI.value,10)||0,0,255);
    return { r:r, g:g, b:b, ok: rI.value!=='' && gI.value!=='' && bI.value!=='' };
  }
  var rgbMatch = document.getElementById('rgbMatch');
  function updateRgbMatch(v){
    if (!v.ok){ rgbMatch.style.display = 'none'; return; }
    var n = nearestCode(v.r, v.g, v.b);
    rgbMatch.style.display = 'flex';
    rgbMatch.innerHTML = '<span class="rgb-match__chip" style="background:' + n.hex + '"></span>Closest stock yarn: <strong>' + n.code + ' ' + n.name + '</strong>';
  }
  [rI,gI,bI].forEach(function(inp){ inp.addEventListener('input', function(){
    var v = rgbVals();
    chip.style.background = v.ok ? 'rgb(' + v.r + ',' + v.g + ',' + v.b + ')' : '#fff';
    updateRgbMatch(v);
  }); });
  document.getElementById('rgbUse').addEventListener('click', function(){
    var v = rgbVals();
    if (!v.ok){ showError('Enter all three RGB values (0\u2013255) to use a custom colour.'); return; }
    hideError();
    state.custom = v;
    Array.prototype.forEach.call(swWrap.children, function(s){ s.classList.remove('swatch--active'); });
    renderAll();
  });

  // logo upload
  var dz = document.getElementById('dropzone');
  var input = document.getElementById('logoInput');
  var fileOut = document.getElementById('dropFile');
  var logoRemove = document.getElementById('logoRemove');
  dz.addEventListener('click', function(){ input.click(); });
  dz.addEventListener('dragover', function(e){ e.preventDefault(); dz.classList.add('dropzone--over'); });
  dz.addEventListener('dragleave', function(){ dz.classList.remove('dropzone--over'); });
  dz.addEventListener('drop', function(e){ e.preventDefault(); dz.classList.remove('dropzone--over'); if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]); });
  input.addEventListener('change', function(){ if (this.files.length) handleFile(this.files[0]); });
  function handleFile(f){
    state.logoName = f.name;
    fileOut.style.display = 'block';
    logoRemove.style.display = 'inline-block';
    var previewable = /^image\/(png|jpe?g|svg\+xml)$/.test(f.type);
    if (previewable){
      var reader = new FileReader();
      reader.onload = function(e){ state.logoDataUrl = e.target.result; fileOut.innerHTML = '&#10003; <strong>' + f.name + '</strong> uploaded &mdash; showing in your live preview'; renderAll(); };
      reader.readAsDataURL(f);
    } else {
      state.logoDataUrl = null;
      fileOut.innerHTML = '&#10003; <strong>' + f.name + '</strong> uploaded &mdash; vector files are previewed in your design proof';
      renderAll();
    }
  }
  logoRemove.addEventListener('click', function(){
    state.logoDataUrl = null; state.logoName = null;
    input.value = '';
    fileOut.style.display = 'none';
    fileOut.innerHTML = '';
    logoRemove.style.display = 'none';
    renderAll();
  });

  // markings toggles
  var optBorder = document.getElementById('optBorder');
  var optMarks = document.getElementById('optMarks');
  optBorder.addEventListener('click', function(){ state.border = !state.border; optBorder.classList.toggle('placement-opt--active', state.border); renderAll(); });
  optMarks.addEventListener('click', function(){ state.marks = !state.marks; optMarks.classList.toggle('placement-opt--active', state.marks); renderAll(); });

  // freight toggle (drives the live estimate)
  var freightOpts = document.querySelectorAll('#freightToggle .freight-opt');
  freightOpts.forEach(function(opt){
    opt.addEventListener('click', function(){
      state.freight = opt.getAttribute('data-mode');
      freightOpts.forEach(function(o){ o.classList.remove('freight-opt--active'); });
      opt.classList.add('freight-opt--active');
      renderAll();
    });
  });

  // placement
  var placeOpts = document.querySelectorAll('#placementRow .placement-opt');
  placeOpts.forEach(function(opt){
    opt.addEventListener('click', function(){
      placeOpts.forEach(function(o){ o.classList.remove('placement-opt--active'); });
      opt.classList.add('placement-opt--active');
      state.placement = opt.getAttribute('data-placement');
      renderAll();
    });
  });

  // logo rotate + move controls
  var logoRotEl = document.getElementById('logoRot');
  var logoRotVal = document.getElementById('logoRotVal');
  logoRotEl.addEventListener('input', function(){
    state.logoRot = parseInt(this.value, 10) || 0;
    logoRotVal.textContent = state.logoRot + '\u00b0';
    if (state.placement === 'centre' && logoSlotEl){ applyLogoTransform(logoSlotEl); }
    else { renderPreview(); }
  });
  document.getElementById('logoReset').addEventListener('click', function(){
    state.logoX = 50; state.logoY = 50; state.logoRot = 0;
    logoRotEl.value = 0; logoRotVal.textContent = '0\u00b0';
    renderPreview();
  });

  // errors
  var errBox = document.getElementById('cfgError');
  function showError(msg){ errBox.textContent = msg; errBox.style.display = 'block'; errBox.scrollIntoView({behavior:'smooth', block:'center'}); }
  function hideError(){ errBox.style.display = 'none'; }

  // Render the configured turf to a PNG so the CRM record shows exactly what
  // the customer designed - same state the live preview uses, drawn to scale.
  function renderDesignImage(){
    return new Promise(function(resolve){
      try {
        var PPM = Math.min(90, Math.max(30, Math.round(1800 / state.l)));  // px per metre
        var tw = Math.round(state.l * PPM), th = Math.round(state.w * PPM);
        var pad = 60, capH = 132;
        var cv = document.createElement('canvas');
        cv.width = tw + pad * 2; cv.height = th + pad * 2 + capH;
        var x = cv.getContext('2d');
        if (!x) { resolve(null); return; }

        x.fillStyle = '#F5F5F5'; x.fillRect(0, 0, cv.width, cv.height);

        var c = activeColour();
        x.fillStyle = c.hex; x.fillRect(pad, pad, tw, th);

        // fine speckle so it reads as turf, not a flat block
        x.save(); x.beginPath(); x.rect(pad, pad, tw, th); x.clip();
        for (var i = 0; i < (tw * th) / 90; i++) {
          x.fillStyle = (i % 2) ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.10)';
          x.fillRect(pad + Math.random() * tw, pad + Math.random() * th, 2, 2);
        }
        x.restore();

        var bw = Math.max(3, Math.round(PPM * 0.05));
        if (state.border) {
          x.strokeStyle = '#FFFFFF'; x.lineWidth = bw;
          x.strokeRect(pad + bw / 2, pad + bw / 2, tw - bw, th - bw);
        }
        if (state.marks) {
          x.fillStyle = 'rgba(255,255,255,0.92)';
          var inset = state.border ? bw + 4 : 3, dl = Math.max(8, PPM * 0.22);
          for (var m = 1; m < state.l; m++) {
            var mx = pad + Math.round(m * PPM);
            x.fillRect(mx, pad + inset, 2, dl);
            x.fillRect(mx, pad + th - inset - dl, 2, dl);
          }
        }

        function caption(){
          x.fillStyle = '#222222';
          x.font = 'bold 26px Poppins, Arial, sans-serif';
          x.fillText('VERVE Custom Logo Turf', pad, pad + th + 46);
          x.font = '20px Poppins, Arial, sans-serif'; x.fillStyle = '#707070';
          var marks = (state.border ? 'White border' : '') +
                      (state.border && state.marks ? ' + ' : '') +
                      (state.marks ? 'Metre dashes' : '') || 'No markings';
          x.fillText(fmt(state.w) + ' m x ' + fmt(state.l) + ' m  |  ' + c.label +
                     '  |  ' + marks, pad, pad + th + 80);
          x.fillText(CFG.isUs ? CFG.usCopy.quote_caption : ((state.freight === 'air' ? 'Priority (air) 6-8 weeks' : 'Standard (sea) 12-16 weeks') +
                     '  |  Est. $' + estimate().inc.toLocaleString('en-AU') + ' inc GST'),
                     pad, pad + th + 112);
          // dimension labels
          x.fillStyle = '#929292'; x.font = '18px Poppins, Arial, sans-serif';
          x.fillText(fmt(state.l) + ' m', pad + tw / 2 - 18, pad - 18);
          x.save(); x.translate(pad - 20, pad + th / 2); x.rotate(-Math.PI / 2);
          x.fillText(fmt(state.w) + ' m', -18, 0); x.restore();
          try { cv.toBlob(function(b){ resolve(b); }, 'image/png'); }
          catch (err) { resolve(null); }
        }

        function drawLogos(img){
          var count = state.placement === 'repeat' ? Math.max(2, Math.round(state.l / 5)) : 1;
          var maxH = th * 0.62, maxW = (tw / count) * 0.7;
          var sc = Math.min(maxW / img.width, maxH / img.height);
          var lw = img.width * sc, lh = img.height * sc;
          for (var i = 0; i < count; i++) {
            var cx, cy;
            if (count === 1) { cx = pad + tw * (state.logoX / 100); cy = pad + th * (state.logoY / 100); }
            else { cx = pad + (tw / count) * (i + 0.5); cy = pad + th / 2; }
            x.save(); x.translate(cx, cy); x.rotate(state.logoRot * Math.PI / 180);
            x.drawImage(img, -lw / 2, -lh / 2, lw, lh); x.restore();
          }
          caption();
        }

        if (state.logoDataUrl) {
          var img = new Image();
          img.onload = function(){ try { drawLogos(img); } catch (e) { caption(); } };
          img.onerror = function(){ caption(); };
          img.src = state.logoDataUrl;
        } else {
          // vector upload (AI/EPS/PDF) has no on-page preview - note it instead
          x.fillStyle = 'rgba(255,255,255,0.85)';
          x.font = 'bold 22px Poppins, Arial, sans-serif';
          x.textAlign = 'center';
          x.fillText(state.logoName ? ('LOGO: ' + state.logoName + ' (vector - see attached file)') : 'LOGO TBC',
                     pad + tw / 2, pad + th / 2);
          x.textAlign = 'left';
          caption();
        }
      } catch (err) { resolve(null); }
    });
  }

  // submit (mockup)
  document.getElementById('submitBtn').addEventListener('click', function(){
    var name = document.getElementById('fName').value.trim();
    var email = document.getElementById('fEmail').value.trim();
    if (!state.logoName){ showError('Upload your logo in Step 3 \u2014 or if you don\u2019t have a file yet, mention it in the notes and we\u2019ll help.'); return; }
    if (!name || !/.+@.+\..+/.test(email)){ showError('Add your name and a valid email in Step 5 so we can send your quote and renders.'); return; }
    hideError();

    // Write the configuration into hidden line-item properties, then submit
    // the real Shopify product form (multipart, so the logo file uploads too).
    var e = estimate();
    var c = activeColour();
    function setProp(id, val){ var el=document.getElementById(id); if(el) el.value = val; }
    setProp('propWidth',    fmt(state.w) + ' m');
    setProp('propLength',   fmt(state.l) + ' m');
    setProp('propArea',     (Math.round(state.w*state.l*10)/10) + ' m2');
    setProp('propColour',   c.label);
    setProp('propRGB',      state.custom ? (state.custom.r+','+state.custom.g+','+state.custom.b) : 'n/a');
    setProp('propMarkings', (state.border?'White border':'') + (state.border&&state.marks?' + ':'') + (state.marks?'Metre dashes':'') || 'None');
    setProp('propLogoPlace',state.placement === 'repeat' ? 'Repeated along the run' : 'Single');
    setProp('propLogoRot',  state.logoRot + ' deg');
    setProp('propLogoPos',  Math.round(state.logoX) + '% x ' + Math.round(state.logoY) + '%');
    setProp('propFreight',  CFG.isUs ? CFG.usCopy.quote_delivery : (state.freight === 'air' ? 'Priority (air)' : 'Standard (sea)'));
    setProp('propLead',     CFG.isUs ? CFG.usCopy.quote_delivery : (state.freight === 'air' ? '6-8 weeks' : '12-16 weeks'));
    setProp('propEstimate', CFG.isUs ? CFG.usCopy.quote_total : ('$' + e.inc.toLocaleString('en-AU') + ' inc GST (estimate)'));
    setProp('propName',     name);
    setProp('propEmail',    email);
    setProp('propBusiness', (document.getElementById('fBiz')||{}).value || '');
    setProp('propPhone',    (document.getElementById('fPhone')||{}).value || '');
    setProp('propNotes',    (document.getElementById('fNotes')||{}).value || '');

    var btn = this;
    btn.disabled = true;
    btn.innerHTML = 'Sending your request\u2026';

    // Capture the lead in HubSpot FIRST, so an abandoned checkout still
    // reaches the team. Then submit the Shopify form (which carries the
    // logo file through to the order).
    function goToShopify(){
      try { document.getElementById('turf-request-form').submit(); }
      catch (err) { window.location.href = '/cart'; }
    }
    var HS = (window.VERVE_TURF_HUBSPOT || {});
    if (!HS.portalId || !HS.formGuid) { goToShopify(); return; }

    var parts = name.split(/\s+/);
    var cfg = {
      width_m: state.w, length_m: state.l,
      area_m2: Math.round(state.w * state.l * 10) / 10,
      colour: c.label,
      custom_rgb: state.custom ? (state.custom.r+','+state.custom.g+','+state.custom.b) : null,
      markings: (state.border?'White border':'') + (state.border&&state.marks?' + ':'') + (state.marks?'Metre dashes':'') || 'None',
      logo_file: state.logoName || null,
      logo_placement: state.placement === 'repeat' ? 'Repeated along the run' : 'Single',
      logo_rotation_deg: state.logoRot,
      delivery: CFG.isUs ? CFG.usCopy.quote_delivery : (state.freight === 'air' ? 'Priority (air)' : 'Standard (sea)'),
      lead_time: CFG.isUs ? CFG.usCopy.quote_delivery : (state.freight === 'air' ? '6-8 weeks' : '12-16 weeks'),
      estimate_ex_gst: CFG.isUs ? CFG.usCopy.quote_total : ('$' + e.ex.toLocaleString('en-AU')),
      estimate_inc_gst: CFG.isUs ? CFG.usCopy.quote_total : ('$' + e.inc.toLocaleString('en-AU'))
    };
    var fields = [
      { objectTypeId:'0-1', name:'firstname', value: parts.shift() || name },
      { objectTypeId:'0-1', name:'lastname',  value: parts.join(' ') },
      { objectTypeId:'0-1', name:'email',     value: email },
      { objectTypeId:'0-1', name:'phone',     value: (document.getElementById('fPhone')||{}).value || '' },
      { objectTypeId:'0-1', name:'company',   value: (document.getElementById('fBiz')||{}).value || '' },
      { objectTypeId:'0-1', name:'message',   value: (document.getElementById('fNotes')||{}).value || '' },
      { objectTypeId:'0-1', name:'configuration_json', value: JSON.stringify(cfg) },
      { objectTypeId:'0-1', name:'configuration_url',  value: window.location.href }
    ].filter(function(f){ return f.value !== ''; });

    var done = false;
    function once(){ if (done) return; done = true; goToShopify(); }
    setTimeout(once, 9000);   // hard ceiling - never trap the customer

    function postToHubSpot(logoUrl, designUrl){
      if (logoUrl)   fields.push({ objectTypeId:'0-1', name:'turf_logo_url',   value: logoUrl });
      if (designUrl) fields.push({ objectTypeId:'0-1', name:'turf_design_url', value: designUrl });
      return fetch('https://api.hsforms.com/submissions/v3/integration/submit/'
            + HS.portalId + '/' + HS.formGuid, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields: fields, context: {
          pageUri: window.location.href,
          pageName: document.title,
          hutk: (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1] || undefined
        }})
      });
    }

    // Try to ship the logo to HubSpot's file manager via the VERVE worker
    // first, so the CRM record carries a real link. If the worker is
    // unreachable we still send the lead - just without the file URL.
    var fileEl = document.getElementById('logoInput');
    var theFile = fileEl && fileEl.files && fileEl.files[0];

    function upload(blob, filename){
      if (!HS.logoUploadUrl || !blob) return Promise.resolve(null);
      var fd = new FormData();
      fd.append('file', blob, filename);
      var ac = ('AbortController' in window) ? new AbortController() : null;
      if (ac) setTimeout(function(){ try { ac.abort(); } catch(e){} }, 6000);
      return fetch(HS.logoUploadUrl, { method:'POST', body: fd, signal: ac ? ac.signal : undefined })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){ return (j && j.url) || null; })
        .catch(function(){ return null; });
    }

    // Ship the customer's logo AND a render of their design, in parallel.
    // Either can fail without stopping the lead from reaching HubSpot.
    var safeName = (state.logoName || 'logo').replace(/[^\w.\- ]+/g, '_');
    renderDesignImage().then(function(designBlob){
      return Promise.all([
        upload(theFile, safeName),
        upload(designBlob, 'turf-design-' + Math.round(state.w*10)/10 + 'x' + Math.round(state.l*10)/10 + 'm.png')
      ]);
    }).then(function(urls){
      return postToHubSpot(urls[0], urls[1]);
    }).then(once).catch(function(){
      postToHubSpot(null, null).then(once).catch(once);
    });
  });

  window.addEventListener('resize', renderPreview);
  renderAll();
})();

